import { useSelector } from "react-redux";

const SubscriptionDetails = () => {
    const { detailsData } = useSelector((state) => state.subscription);
    console.log("Subscription Details >> ", detailsData);

    const renderLimit = (value) => value ?? "No Limit";

    // function formatTime(value) {
    //     if (value <= 48) {
    //         return `${value} hour${value !== 1 ? 's' : ''}`;
    //     } else if (value <= 24 * 30) {
    //         let days = Math.floor(value / 24);
    //         return `${days} day${days !== 1 ? 's' : ''}`;
    //     } else if (value <= 24 * 365) {
    //         let months = Math.floor(value / (24 * 30));
    //         return `${months} month${months !== 1 ? 's' : ''}`;
    //     } else {
    //         let years = Math.floor(value / (24 * 365));
    //         return `${years} year${years !== 1 ? 's' : ''}`;
    //     }
    // }
    return (
        <div>
            <div className="row fs-7 mb-3">
                <div className="col-md-3">
                    <strong className="fs-7">Name: </strong>
                    <p>{detailsData?.name || null}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Price Monthly: </strong>
                    <p>{(detailsData?.price_monthly === 0 || detailsData?.price_monthly === null) ? detailsData?.id === 1 ? 'Free' : "NA" : "$ " + detailsData.price_monthly}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Price Annually: </strong>
                    <p>{(detailsData?.price_annually === 0 || detailsData?.price_annually === null) ? detailsData?.id === 1 ? 'Free' : "NA" : "$ " + detailsData?.price_annually}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Trial Period: </strong>
                    <p>{Number(detailsData?.trialperiod ?? 0)} Days</p>
                </div>
            </div>

            <div className="row fs-7 mb-3">
                <div className="col-md-12">
                    <strong className="fs-7">Description: </strong>
                    <p className="text-justify">{detailsData?.description || null}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Ads: </strong>
                    <p>{Number(detailsData.is_ads) === 1 ? 'Yes' : 'No'}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Hunt Hosting Credits: </strong>
                    <p>{detailsData?.max_hunts}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Max saved Quest </strong>
                    <p>{renderLimit(detailsData?.max_challenges)}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Max saved hunt: </strong>
                    <p>{renderLimit(detailsData?.max_saved_hunt)}</p>
                </div>
            </div>

            <div className="row fs-7 mb-3">
                <div className="col-md-3">
                    <strong className="fs-7">Max Challenges per Quest: </strong>
                    <p>{renderLimit(detailsData?.max_challenge_items)}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Max Challenges per Hunt: </strong>
                    <p>{renderLimit(detailsData?.max_hunt_items)}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Max created Challenges in Library: </strong>
                    <p>{renderLimit(detailsData?.max_created_items)}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Max purchased challenges in Library: </strong>
                    <p>{renderLimit(detailsData?.max_purchased_items)}</p>
                </div>
            </div>

            <div className="row fs-7 mb-3">
                <div className="col-md-3">
                    <strong className="fs-7">Max Teams for Hunt: </strong>
                    <p>{renderLimit(detailsData?.max_hunt_teams)}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Relaunch Hunts: </strong>
                    <p>{detailsData.is_relaunch === 1 ? 'Yes' : 'No'}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Relaunch Quests: </strong>
                    <p>{detailsData?.is_relaunch_quests === 1 ? 'Yes' : 'No'}</p>
                </div>
                <div className="col-md-3">
                    <strong className="fs-7">Days video stored in app: </strong>
                    <p>{detailsData.video_available} Days</p>
                </div>
            </div>

            <div className="row fs-7 mb-3">
                <div className="col-md-3">
                    <strong className="fs-7">Max Share per Quests: </strong>
                    <p>{detailsData?.max_share ?? 0}</p>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionDetails;
